/* ============================================================
   SILCAP THEME — Core JavaScript (v4, Turkish)
   ============================================================ */
'use strict';

/* ── Yardımcı Fonksiyonlar ────────────────────────────────── */
function formatMoney(cents) {
  if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
  return '₺' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
}
/** suggest.json ürününde price / price_min / price_max = ana birim ondalık (örn. 149), kuruş değil */
function formatMoneyFromSuggestDecimal(decimal) {
  if (decimal == null || decimal === '') return formatMoney(0);
  var s = String(decimal).replace(/\s/g, '').replace(',', '.');
  var n = parseFloat(s);
  if (isNaN(n) || n < 0) return formatMoney(0);
  return formatMoney(Math.round(n * 100));
}
function suggestProductPriceLabel(p) {
  var min = p.price_min;
  var max = p.price_max;
  if (min != null && max != null && Number(min) !== Number(max)) {
    return formatMoneyFromSuggestDecimal(min) + ' – ' + formatMoneyFromSuggestDecimal(max);
  }
  if (min != null) return formatMoneyFromSuggestDecimal(min);
  if (p.price != null) return formatMoneyFromSuggestDecimal(p.price);
  return formatMoney(0);
}
function escHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
function escAttr(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}
function silcapRoutesRoot() {
  var r = window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string'
    ? window.Shopify.routes.root
    : '/';
  return r.slice(-1) === '/' ? r : r + '/';
}
function debounce(fn, delay) {
  var t; return function() { var a=arguments,c=this; clearTimeout(t); t=setTimeout(function(){ fn.apply(c,a); }, delay); };
}
async function fetchJSON(url, opts) {
  var res = await fetch(url, Object.assign({ headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'} }, opts));
  if (!res.ok) throw new Error(res.statusText);
  return res.json();
}
function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} })); }
function isMobile() { return window.innerWidth <= 768 || 'ontouchstart' in window; }

/** ai-features.js ve diğer modüller için ortak API */
window.Silcap = {
  formatMoney: formatMoney,
  formatMoneyFromSuggestDecimal: formatMoneyFromSuggestDecimal,
  suggestProductPriceLabel: suggestProductPriceLabel,
  fetchJSON: fetchJSON,
  emit: emit
};

/* ── Sticky Header ────────────────────────────────────────── */
(function() {
  var h = document.getElementById('SilcapHeader');
  if (!h) return;
  var s = window.scrollY > 10;
  h.classList.toggle('scrolled', s);
  document.addEventListener('scroll', function() {
    var now = window.scrollY > 10;
    if (now !== s) { s = now; h.classList.toggle('scrolled', s); }
  }, { passive: true });
})();

/* ── Announcement Bar Dismiss (sessionStorage — sonraki yüklemelerde head script ile gizlenir) */
(function() {
  var btn = document.getElementById('AnnouncementClose');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var bar = document.getElementById('AnnouncementBar');
    if (bar) bar.style.display = 'none';
    try {
      sessionStorage.setItem('silcap_announcement_dismissed', '1');
      document.documentElement.classList.add('silcap-announcement-dismissed');
    } catch (e) {}
  });
})();

/* ── Mobil Navigasyon ─────────────────────────────────────── */
(function() {
  var drawer  = document.getElementById('MobileNavDrawer');
  var overlay = document.getElementById('PageOverlay');
  var openBtns = document.querySelectorAll('[data-mobile-nav-open]');
  var closeBtn = document.getElementById('MobileNavClose');
  if (!drawer) return;
  function open() {
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    overlay?.classList.add('is-visible'); document.body.style.overflow = 'hidden';
    if (openBtns[0]) openBtns[0].setAttribute('aria-expanded','true');
  }
  function close() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    overlay?.classList.remove('is-visible'); document.body.style.overflow = '';
    if (openBtns[0]) openBtns[0].setAttribute('aria-expanded','false');
  }
  openBtns.forEach(function(b){ b.addEventListener('click', open); });
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', function() {
    close();
    closeSearch();
    closeCart();
  });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { close(); closeSearch(); closeCart(); } });
})();

/* ── Arama Çekmecesi ──────────────────────────────────────── */
var closeSearch;
(function() {
  var drawer = document.getElementById('SearchDrawer');
  var overlay = document.getElementById('PageOverlay');
  var openBtns = document.querySelectorAll('[data-search-open]');
  var closeBtn = document.getElementById('SearchClose');
  var input = document.getElementById('SearchInput');
  var clearBtn = document.getElementById('SearchClear');
  var suggestionsEl = document.getElementById('SearchSuggestions');
  var viewAllBtn = document.getElementById('SearchViewAll');
  if (!drawer) { closeSearch = function(){}; return; }

  function open() {
    drawer.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ input?.focus(); }, 80);
  }
  closeSearch = function() {
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  };
  openBtns.forEach(function(b){ b.addEventListener('click', open); });
  closeBtn?.addEventListener('click', closeSearch);
  clearBtn?.addEventListener('click', function() { if(input) { input.value=''; input.focus(); } if(suggestionsEl) suggestionsEl.innerHTML=''; if(viewAllBtn) viewAllBtn.style.display='none'; });

  var dSearch = debounce(async function(q) {
    if (!suggestionsEl) return;
    if (q.length < 2) { suggestionsEl.innerHTML = ''; if(viewAllBtn) viewAllBtn.style.display='none'; return; }
    try {
      var cfg = window.SilcapConfig || {};
      if (!cfg.predictiveSearchEnabled) {
        suggestionsEl.innerHTML = '<div style="padding:10px;font-size:13px;color:var(--color-text-muted);">Önerilen arama vitrin ayarında kapalı.</div>';
        return;
      }
      var root = silcapRoutesRoot();
      var qs =
        'q=' + encodeURIComponent(q) +
        '&resources[type]=product' +
        '&resources[limit]=10' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      var data = await fetchJSON(root + 'search/suggest.json?' + qs);
      var prods = data && data.resources && data.resources.results && data.resources.results.products
        ? data.resources.results.products
        : [];
      suggestionsEl.innerHTML = prods.length ? prods.map(function(p) {
        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        var title = p.title || '';
        var href = p.url || '#';
        return '<a href="' + escAttr(href) + '" class="search-suggestion-item">' +
          '<img src="' + escAttr(img) + '" alt="' + escAttr(title) + '" loading="lazy" onerror="this.style.display=\'none\'">' +
          '<div class="search-suggestion-item__info">' +
            '<div class="search-suggestion-item__title">' + escHtml(title) + '</div>' +
            '<div class="search-suggestion-item__price">' + suggestProductPriceLabel(p) + '</div>' +
          '</div></a>';
      }).join('') : '<div style="padding:10px;font-size:13px;color:var(--color-text-muted);">Sonuç bulunamadı.</div>';
      if (viewAllBtn) {
        viewAllBtn.style.display = prods.length ? 'inline-flex' : 'none';
        viewAllBtn.href = root + 'search?q=' + encodeURIComponent(q) + '&type=product';
      }
    } catch (e) {
      if (suggestionsEl) {
        suggestionsEl.innerHTML = '<div style="padding:10px;font-size:13px;color:var(--color-text-muted);">Arama yüklenemedi. Tam arama sayfasını deneyin.</div>';
      }
    }
  }, 300);

  input?.addEventListener('input', function() { dSearch(this.value.trim()); });
})();

/* ── Sepet Yöneticisi ─────────────────────────────────────── */
var closeCart;
(function() {
  var drawer  = document.getElementById('CartDrawer');
  var overlay = document.getElementById('PageOverlay');
  var body    = document.getElementById('CartDrawerBody');
  var closeBtn = document.getElementById('CartClose');
  var openBtns = document.querySelectorAll('[data-cart-open]');
  var cfgShip = window.SilcapConfig || {};
  var FREE_SHIP_THRESHOLD = Number(cfgShip.freeShippingThreshold);
  if (!FREE_SHIP_THRESHOLD || FREE_SHIP_THRESHOLD <= 0) FREE_SHIP_THRESHOLD = 100000;
  var STANDARD_SHIPPING_FEE = Number(cfgShip.standardShippingFee);
  if (!STANDARD_SHIPPING_FEE || STANDARD_SHIPPING_FEE <= 0) STANDARD_SHIPPING_FEE = 11600;
  var checkoutUrl = (drawer && drawer.getAttribute('data-checkout-url')) ? drawer.getAttribute('data-checkout-url') : '/checkout';

  if (!drawer) { closeCart = function(){}; return; }

  function setCheckoutEnabled(enabled) {
    var btn = document.getElementById('CartCheckoutBtn');
    if (!btn) return;
    if (enabled) {
      btn.setAttribute('href', checkoutUrl);
      btn.classList.remove('is-disabled');
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('tabindex');
    } else {
      btn.setAttribute('href', '#');
      btn.classList.add('is-disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
    }
  }

  function open() {
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    overlay?.classList.add('is-visible'); document.body.style.overflow = 'hidden';
    refreshCart();
  }
  closeCart = function() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    overlay?.classList.remove('is-visible'); document.body.style.overflow = '';
  };
  openBtns.forEach(function(b){ b.addEventListener('click', open); });
  closeBtn?.addEventListener('click', closeCart);

  async function refreshCart() {
    try {
      var cart = await fetchJSON('/cart.js');
      renderCart(cart);
      updateCartBadge(cart.item_count);
      updateShippingProgress(cart.total_price);
    } catch(e) {}
  }

  function renderCart(cart) {
    if (!body) return;
    var total = document.querySelector('[data-cart-total]');
    var count = document.querySelector('.cart-drawer__count');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (count) count.textContent = cart.item_count;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon"><svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></div><p class="cart-empty__title">Sepetiniz boş</p><p class="cart-empty__sub">Harika ürünlerimizi keşfedin</p><a href="/collections/all" class="btn btn-primary btn-sm">Alışverişe Başla</a></div>';
      setCheckoutEnabled(false);
      return;
    }
    body.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '"><img class="cart-item__img" src="' + (item.image || '') + '" alt="' + (item.title||'').replace(/"/g,'&quot;') + '" loading="lazy" onerror="this.style.display=\'none\'"></a>' +
        '<div>' +
          '<div class="cart-item__title"><a href="' + item.url + '">' + (item.product_title||item.title) + '</a></div>' +
          (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Varsayılan Başlık' ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '') +
          '<div class="cart-item__bottom">' +
            '<div class="quantity-control" style="height:34px;">' +
              '<button class="quantity-btn" type="button" data-cart-qty data-key="' + item.key + '" data-delta="-1" style="height:34px;width:32px;">−</button>' +
              '<input class="quantity-input" value="' + item.quantity + '" readonly style="height:34px;width:38px;font-size:13px;">' +
              '<button class="quantity-btn" type="button" data-cart-qty data-key="' + item.key + '" data-delta="1" style="height:34px;width:32px;">+</button>' +
            '</div>' +
            '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button class="cart-item__remove" type="button" data-cart-remove="' + item.key + '" aria-label="Kaldır">✕</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    body.querySelectorAll('[data-cart-qty]').forEach(function(btn) {
      btn.addEventListener('click', async function() {
        var key = this.dataset.key, delta = parseInt(this.dataset.delta);
        var inp = this.closest('.quantity-control')?.querySelector('.quantity-input');
        var current = parseInt(inp?.value || 1);
        await updateCartItem(key, Math.max(0, current + delta));
      });
    });
    body.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', async function() { await updateCartItem(this.dataset.cartRemove, 0); });
    });
    setCheckoutEnabled(true);
  }

  async function updateCartItem(key, qty) {
    try {
      var cart = await fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) });
      renderCart(cart);
      updateCartBadge(cart.item_count);
      updateShippingProgress(cart.total_price);
      emit('cart:updated', { cart: cart });
    } catch(e) {}
  }

  function updateShippingProgress(price) {
    var fill = document.getElementById('ShippingProgressFill');
    var msg  = document.getElementById('ShippingProgressMsg');
    if (!fill || !msg) return;
    var pct = Math.min(100, price / FREE_SHIP_THRESHOLD * 100);
    fill.style.width = pct + '%';
    if (price >= FREE_SHIP_THRESHOLD) {
      msg.textContent = '🎉 Ücretsiz kargo kazandınız!';
      msg.style.color = 'var(--color-accent)';
    } else {
      var left = formatMoney(FREE_SHIP_THRESHOLD - price);
      var freeTl = Math.round(FREE_SHIP_THRESHOLD / 100);
      msg.textContent =
        'Ücretsiz kargo için ' +
        left +
        ' daha. ' +
        freeTl +
        ' TL altı standart ' +
        formatMoney(STANDARD_SHIPPING_FEE) +
        '.';
      msg.style.color = '';
    }
  }

  /* Sepete Ekle — global dinleyici */
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-pc-atc]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var variantId = btn.dataset.pcAtc;
    if (!variantId) return;
    var orig = btn.innerHTML;
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="loading-spinner"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".2"/><path d="M21 12a9 9 0 0 1-9 9"/></svg>';
    btn.disabled = true;
    try {
      var cart = await fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ id: variantId, quantity: 1 }) });
      await fetchJSON('/cart.js').then(function(c) {
        renderCart(c); updateCartBadge(c.item_count); updateShippingProgress(c.total_price);
        emit('cart:updated', { cart: c });
      });
      var badge = document.querySelector('[data-cart-count]');
      badge?.classList.add('bump'); setTimeout(function(){ badge?.classList.remove('bump'); }, 400);
      open();
    } catch(err) {
      showToast('Ürün sepete eklenemedi. Lütfen tekrar deneyin.', 'error');
    } finally {
      btn.innerHTML = orig; btn.disabled = false;
    }
  });

  /* Ürün sayfası ATC formu */
  document.addEventListener('submit', async function(e) {
    var form = e.target.closest('#ProductForm');
    if (!form) return;
    e.preventDefault();
    var atcBtn = form.querySelector('#AddToCartBtn');
    var variantId = form.querySelector('#VariantId')?.value;
    var qty = parseInt(form.querySelector('#Quantity')?.value || 1);
    if (!variantId) return;
    var orig = atcBtn?.innerHTML;
    if (atcBtn) { atcBtn.disabled = true; atcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="loading-spinner"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".2"/><path d="M21 12a9 9 0 0 1-9 9"/></svg> Ekleniyor...'; }
    try {
      await fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ id: parseInt(variantId), quantity: qty }) });
      var cart = await fetchJSON('/cart.js');
      renderCart(cart); updateCartBadge(cart.item_count); updateShippingProgress(cart.total_price);
      emit('cart:updated', { cart: cart });
      open();
    } catch(err) {
      showToast('Ürün sepete eklenemedi. Stok kontrolü yapın.', 'error');
    } finally {
      if (atcBtn) { atcBtn.disabled = false; atcBtn.innerHTML = orig || 'Sepete Ekle'; }
    }
  });

  refreshCart();
})();

/* ── Sepet Badge Güncelle ─────────────────────────────────── */
function updateCartBadge(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
}

/* ── Toast Bildirimi ──────────────────────────────────────── */
function showToast(msg, type) {
  var t = document.getElementById('WishlistToast');
  var msgEl = document.getElementById('WishlistToastMsg');
  if (!t) {
    t = document.createElement('div');
    t.id = 'WishlistToast'; t.className = 'wishlist-toast';
    t.innerHTML = '<span id="WishlistToastMsg"></span>';
    document.body.appendChild(t);
  }
  var m = t.querySelector('#WishlistToastMsg') || t;
  m.textContent = msg;
  t.style.background = type === 'error' ? 'var(--color-danger)' : 'var(--color-text)';
  t.style.display = 'flex';
  t.setAttribute('aria-hidden', 'false');
  /* Kısa gecikme sonra animate et */
  requestAnimationFrame(function() { t.classList.add('is-visible'); });
  clearTimeout(t._timer);
  t._timer = setTimeout(function(){
    t.classList.remove('is-visible');
    setTimeout(function(){ t.style.display = 'none'; t.setAttribute('aria-hidden','true'); }, 300);
  }, 3200);
}

/* ── Favori (Wishlist) ────────────────────────────────────── */
(function() {
  var WL_KEY = 'silcap_wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch(e) { return []; } }
  function save(ids) { try { localStorage.setItem(WL_KEY, JSON.stringify(ids)); } catch(e) {} }
  function syncButtons() {
    var ids = get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var id = String(btn.dataset.wishlistToggle);
      btn.classList.toggle('is-wishlisted', ids.includes(id));
    });
  }
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var id = String(btn.dataset.wishlistToggle);
    var ids = get(); var idx = ids.indexOf(id);
    var added;
    if (idx > -1) { ids.splice(idx,1); added = false; } else { ids.push(id); added = true; }
    save(ids); syncButtons();
    var title = btn.dataset.productTitle || '';
    showToast(added ? (title ? '"' + title.slice(0,30) + '" favorilere eklendi.' : 'Favorilere eklendi.') : 'Favorilerden kaldırıldı.');
  });
  syncButtons();
  document.addEventListener('cart:updated', syncButtons);
})();

/* ── Varyant Seçici ───────────────────────────────────────── */
(function() {
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var scriptEl = document.getElementById('ProductVariantsJSON');
  if (!scriptEl) return;
  var variants;
  try { variants = JSON.parse(scriptEl.textContent); } catch(e) { return; }
  if (!variants || !variants.length) return;

  var selectedOptions = {};
  form.querySelectorAll('[data-option]').forEach(function(group) {
    group.querySelectorAll('[data-value]').forEach(function(btn) {
      if (btn.classList.contains('active')) selectedOptions[group.dataset.option] = btn.dataset.value;
    });
  });

  function findVariant() {
    return variants.find(function(v) {
      return v.option_names.every(function(name, i) { return v.options[i] === selectedOptions[name]; });
    });
  }

  function updateProductWhatsAppLink(variant) {
    var waBtn = document.getElementById('ProductWhatsAppBtn');
    if (!waBtn) return;
    var base = (waBtn.getAttribute('data-wa-base') || 'https://wa.me/905343345577').split('?')[0].split('#')[0];
    var qtyEl = document.getElementById('Quantity');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var title = waBtn.getAttribute('data-product-title') || document.title;
    var url = waBtn.getAttribute('data-product-url') || window.location.href;
    var lines = [
      'Merhaba Silcap Mutfak,',
      '',
      'Aşağıdaki ürünü sipariş etmek istiyorum:',
      '',
      title,
      url
    ];
    if (variant && variant.title && variant.title !== 'Default Title') {
      lines.push('', 'Seçenek: ' + variant.title);
    }
    if (variant && variant.sku) lines.push('Stok kodu: ' + variant.sku);
    lines.push('', 'Adet: ' + qty);
    if (variant && typeof variant.price === 'number') {
      lines.push('Birim fiyat: ' + formatMoney(variant.price));
    }
    waBtn.href = base + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  window.silcapRefreshProductWhatsApp = function() {
    updateProductWhatsAppLink(findVariant());
  };

  function updateForm(variant) {
    var vidInput = document.getElementById('VariantId');
    var priceEl = document.getElementById('ProductPrice');
    var cmpEl = document.getElementById('ProductCompare');
    var atcBtn = document.getElementById('AddToCartBtn');
    var skuEl = document.getElementById('ProductSKU');
    if (!variant) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.innerHTML = 'Mevcut Değil'; }
      return;
    }
    if (vidInput) vidInput.value = variant.id;
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price || 0);
      priceEl.classList.toggle('price--sale', variant.compare_at_price > variant.price);
    }
    if (cmpEl) {
      if (variant.compare_at_price > variant.price) { cmpEl.textContent = formatMoney(variant.compare_at_price); cmpEl.style.display = ''; }
      else { cmpEl.style.display = 'none'; }
    }
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.innerHTML = variant.available ?
        '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Sepete Ekle'
        : 'Tükendi';
    }
    if (skuEl && variant.sku) skuEl.textContent = variant.sku;
    if (variant.featured_image) {
      var mainImg = document.getElementById('ProductMainImg');
      if (mainImg) mainImg.src = variant.featured_image;
    }
    var stockEl = form.closest('.product-info')?.querySelector('.product-info__stock');
    if (stockEl) {
      stockEl.className = 'product-info__stock ' + (variant.available ? 'in-stock' : 'out-stock');
      stockEl.innerHTML = variant.available ? '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>Stokta Var' : 'Stokta Yok';
    }
    updateProductWhatsAppLink(variant);
  }

  window.silcapRefreshProductWhatsApp();

  form.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-option] [data-value]');
    if (!btn) return;
    var group = btn.closest('[data-option]');
    if (!group) return;
    group.querySelectorAll('[data-value]').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    selectedOptions[group.dataset.option] = btn.dataset.value;
    var optLabel = document.getElementById('OptionVal' + (Array.from(form.querySelectorAll('[data-option]')).indexOf(group) + 1));
    if (optLabel) optLabel.textContent = btn.dataset.value;
    updateForm(findVariant());
  });
})();

/* ── Karanlık Mod ─────────────────────────────────────────── */
(function() {
  var key = 'silcap_theme';
  var saved = localStorage.getItem(key);
  if (saved === 'dark') document.documentElement.setAttribute('data-theme','dark');
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    document.documentElement.setAttribute('data-theme', isDark ? 'light' : 'dark');
    try { localStorage.setItem(key, isDark ? 'light' : 'dark'); } catch(x){}
  });
})();

/* ── Hero Slider ──────────────────────────────────────────── */
(function() {
  var root = document.querySelector('[data-hero-slider]');
  if (!root) return;

  var slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
  if (!slides.length) return;

  var dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
  var prevBtn = root.querySelector('[data-hero-prev]');
  var nextBtn = root.querySelector('[data-hero-next]');
  var pauseBtn = root.querySelector('[data-hero-pause]');
  var autoplay = root.dataset.autoplay === 'true';
  var interval = parseInt(root.dataset.interval, 10) || 6000;
  var index = slides.findIndex(function(s) { return s.classList.contains('is-active'); });
  if (index < 0) index = 0;

  var timer = null;
  var paused = false;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach(function(slide, n) {
      slide.classList.toggle('is-active', n === index);
    });
    dots.forEach(function(dot, n) {
      dot.classList.toggle('is-active', n === index);
      dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
    });
  }

  function next() { goTo(index + 1); }
  function prev() { goTo(index - 1); }

  function startAutoplay() {
    if (!autoplay || slides.length < 2 || reducedMotion || paused) return;
    stopAutoplay();
    timer = setInterval(next, interval);
  }

  function stopAutoplay() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  prevBtn?.addEventListener('click', function() { prev(); startAutoplay(); });
  nextBtn?.addEventListener('click', function() { next(); startAutoplay(); });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var i = parseInt(dot.dataset.heroDot, 10);
      if (!isNaN(i)) { goTo(i); startAutoplay(); }
    });
  });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);
  root.addEventListener('focusin', stopAutoplay);
  root.addEventListener('focusout', startAutoplay);

  var touchStartX = 0;
  root.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].clientX;
  }, { passive: true });
  root.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) < 40) return;
    if (dx < 0) next(); else prev();
    startAutoplay();
  }, { passive: true });

  if (pauseBtn) {
    pauseBtn.addEventListener('click', function() {
      paused = !paused;
      pauseBtn.classList.toggle('is-paused', paused);
      pauseBtn.setAttribute('aria-label', paused ? 'Slayt geçişini sürdür' : 'Slayt geçişini duraklat');
      if (paused) stopAutoplay(); else startAutoplay();
    });
  }

  startAutoplay();
})();

/* ── Kaydırma Animasyonları ───────────────────────────────── */
(function() {
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-animate]').forEach(function(el) { obs.observe(el); });
})();

/* ── Yukarı Çıkma Butonu ──────────────────────────────────── */
(function() {
  var btn = document.getElementById('BackToTop');
  if (!btn) return;
  window.addEventListener('scroll', function() { btn.classList.toggle('is-visible', window.scrollY > 400); }, { passive: true });
  btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
})();

/* ── Son görüntülenenler: ai-features.js / RecentlyViewed + silcap_recently_viewed ── */

/* ── AI Chatbot — Akıllı Türkçe Yanıt Sistemi ─────────────── */
(function() {
  'use strict';
  var toggle   = document.getElementById('ChatbotToggle');
  var win      = document.getElementById('ChatbotWindow');
  var sendBtn  = document.getElementById('ChatbotSend');
  var input    = document.getElementById('ChatbotInput');
  var msgs     = document.getElementById('ChatbotMsgs');
  var closeBtn = document.getElementById('ChatbotClose');
  var unread   = document.getElementById('ChatbotUnread');
  var iconOpen = toggle ? toggle.querySelector('.chatbot-icon-open') : null;
  var iconClose= toggle ? toggle.querySelector('.chatbot-icon-close') : null;
  if (!toggle || !win) return;

  var isOpen = false;
  var hasInteracted = false;

  /* ── Yardımcı: mesaj ekle ────────────────────────────────── */
  function addMsg(html, type, delay) {
    if (!msgs) return;
    return new Promise(function(res) {
      setTimeout(function() {
        var m = document.createElement('div');
        m.className = 'ai-chatbot__msg ai-chatbot__msg--' + type;
        m.innerHTML = html;
        msgs.appendChild(m);
        msgs.scrollTop = msgs.scrollHeight;
        res(m);
      }, delay || 0);
    });
  }

  /* ── Yazıyor indikatörü ──────────────────────────────────── */
  function showTyping() {
    var d = document.createElement('div');
    d.className = 'ai-chatbot__msg ai-chatbot__msg--bot ai-chatbot__typing';
    d.id = 'ChatbotTyping';
    d.innerHTML = '<span></span><span></span><span></span>';
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }
  function removeTyping() {
    var t = document.getElementById('ChatbotTyping');
    if (t) t.remove();
  }

  /* ── Öneri butonları ─────────────────────────────────────── */
  function addSuggestions(list) {
    if (!msgs || !list || !list.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'ai-chatbot__suggestions';
    list.forEach(function(s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ai-chatbot__suggestion-btn';
      b.textContent = s;
      b.addEventListener('click', function() {
        wrap.remove();
        if (input) input.value = s;
        sendMessage();
      });
      wrap.appendChild(b);
    });
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  /* ── Yanıt Motoru — Türkçe anahtar kelime eşleme ────────── */
  var KB = [
    {
      keys: ['merhaba','selam','iyi günler','iyi akşamlar','hey','naber','nasılsın'],
      reply: 'Merhaba! 👋 Ben Silcap Asistan\'ım. Ürünler, kargo, iade veya sipariş konularında size yardımcı olabilirim. Ne öğrenmek istersiniz?',
      suggestions: ['Kargo süresi nedir?', 'İade nasıl yapılır?', 'Hangi ürünler var?']
    },
    {
      keys: ['kargo','teslimat','gönderim','kaç günde','ne zaman gelir','hızlı kargo','aynı gün','gönder'],
      reply: '🚚 Kargo bilgileri:\n\n• <strong>Standart kargo:</strong> 3–5 iş günü — <strong>1000 TL altı 116 TL</strong>; <strong>1000 TL ve üzeri ücretsiz</strong>\n• <strong>Hızlı kargo:</strong> 1–2 iş günü — 29,99 TL\n• <strong>Aynı gün teslimat:</strong> Büyük şehirler, saat 14:00 öncesi siparişlerde 49,99 TL\n\nSiparişleriniz genellikle aynı gün kargoya verilir.',
      suggestions: ['Hangi kargo firması?', 'Siparişimi takip etmek istiyorum', 'İade nasıl yapılır?']
    },
    {
      keys: ['iade','geri gönder','para iadesi','değişim','ürünü beğenmedim','bozuk geldi','hasar'],
      reply: '✅ <strong>30 gün koşulsuz iade garantisi</strong> sunuyoruz!\n\nİade koşulları:\n• Ürün orijinal ambalajında olmalı\n• 30 gün içinde talep edilmeli\n• İade kargo ücreti bizden\n\nİade başlatmak için: <strong>iade@silcapmutfak.com</strong> adresine e-posta gönderin veya mağaza panelinizden "Siparişlerim" bölümüne gidin.',
      suggestions: ['Kargo süresi nedir?', 'Ürün garantisi var mı?', 'Sipariş durumumu nasıl görebilirim?']
    },
    {
      keys: ['silikon','kalıp','mold','fırın','ısıya dayanıklı','kaç dereceye','fırında kullanılır'],
      reply: '🍰 Silikon kalıplarımız hakkında bilgi:\n\n• <strong>Gıda güvenli</strong> (FDA & EU onaylı) silikon kullanılır\n• <strong>–40°C ile +230°C</strong> arası dayanıklı\n• Bulaşık makinesinde yıkanabilir\n• Yapışmaz, yağlamaya gerek yok\n• Esnek yapı sayesinde kalıptan kolay çıkar\n\nHangi kalıp modeli hakkında bilgi almak istersiniz?',
      suggestions: ['Kek kalıpları', 'Çikolata kalıpları', 'Buz kalıpları', 'Muffin kalıpları']
    },
    {
      keys: ['fiyat','indirim','kampanya','kupon','iskonto','promosyon','para','kaç tl','kaç lira','ucuz'],
      reply: '💸 Güncel kampanyalarımız:\n\n• <strong>1000 TL ve üzeri</strong> alışverişlerde ücretsiz kargo; altında standart kargo <strong>116 TL</strong>\n• Yeni üyelere özel <strong>%10 indirim</strong> (bülten aboneliği ile)\n• Çok satanlar bölümünde <strong>%40\'a varan</strong> indirimli ürünler var!\n\nKampanya sayfamıza göz atmak ister misiniz?',
      suggestions: ['Kampanyalar', 'En çok satanlar', 'Yeni gelenler']
    },
    {
      keys: ['çikolata','pralin','ganaj','drajee','trüf','bonbon'],
      reply: '🍫 Çikolata kalıplarımız çok çeşitli! Pralin, bonbon, trüf ve dekorasyon kalıplarımız mevcut. Profesyonel kalitede, çelik pim destekli silikon yapısıyla çikolatanın kolayca ayrılmasını sağlar. Çikolata kategorimizi incelemek ister misiniz?',
      suggestions: ['Çikolata kalıplarını göster', 'Pralin kalıpları', 'Fiyatlar nedir?']
    },
    {
      keys: ['kek','muffin','cupcake','pasta','brownie','pişirme','baking'],
      reply: '🎂 Kek ve muffin kalıplarımız çok popüler! Özellikle:\n\n• <strong>Silikon muffin kalıpları</strong> — 6\'lı, 12\'li\n• <strong>Kek kalıpları</strong> — yuvarlak, dikdörtgen, kalp şekilli\n• <strong>Dekoratif Bundt kalıpları</strong> — özel desenli\n\nFırında 200°C\'ye kadar sorunsuz kullanılabilir.',
      suggestions: ['Muffin kalıpları', 'Pasta kalıpları', 'Sepete ekle']
    },
    {
      keys: ['buz','dondurma','ice','cube','buz kalıbı'],
      reply: '🧊 Buz kalıplarımız hem pratik hem estetik! Küre buz kalıpları, çubuk buz kalıpları ve dekoratif buz kalıpları çeşitlerimiz var. Gıda güvenli silikon, -40°C\'ye kadar dayanıklı. Dondurmak için de kullanılabilir!',
      suggestions: ['Buz kalıplarını göster', 'Dondurma kalıpları', 'Fiyat nedir?']
    },
    {
      keys: ['temizlik','nasıl temizlenir','bulaşık makinesi','deterjan','yıkama'],
      reply: '🧼 Ürünlerimiz çok kolay temizlenir:\n\n• <strong>Bulaşık makinesi uyumludur</strong>\n• Sıcak su ve hafif deterjanla el yıkama yapılabilir\n• Güçlü koku ve boyalar için kabartma tozu tozu karışımı önerilir\n• Tamamen kuruyunca saklayın',
      suggestions: ['Ürünler bozulur mu?', 'Garanti var mı?', 'Başka sorum var']
    },
    {
      keys: ['garanti','sağlam','dayanıklı','bozulur','ne kadar süre','kaç yıl'],
      reply: '🛡️ Ürünlerimiz <strong>2 yıl üretici garantisi</strong> ile satılmaktadır. Normal kullanımda şekil bozukluğu, çatlama veya renk değişimi olmaz. Sorun yaşarsanız ücretsiz değişim yapıyoruz!',
      suggestions: ['İade koşulları nedir?', 'Müşteri hizmetleri', 'Sipariş vermek istiyorum']
    },
    {
      keys: ['sipariş','nasıl sipariş','nasıl alınır','satın al','nereden alırım','ödeme','kapıda ödeme'],
      reply: '🛒 Sipariş vermek çok kolay!\n\n1. İstediğiniz ürünü seçin\n2. "Sepete Ekle" butonuna tıklayın\n3. Sepetinizi kontrol edin\n4. Güvenli ödeme sayfasına geçin\n\n<strong>Ödeme seçenekleri:</strong> Kredi kartı, banka kartı, havale/EFT, kapıda ödeme\n\nTüm ödemeler 256-bit SSL ile korunur.',
      suggestions: ['Kapıda ödeme var mı?', 'Kargo ücreti nedir?', 'Hangi bankalar?']
    },
    {
      keys: ['kapıda ödeme','nakit','kapıda'],
      reply: '✅ Evet, <strong>kapıda ödeme</strong> seçeneğimiz mevcuttur! Nakit veya kartlı ödeme yapabilirsiniz. Kapıda ödeme seçeneğinde +5 TL hizmet bedeli uygulanır.',
      suggestions: ['Kargo ücreti nedir?', 'Sipariş vermek istiyorum', 'Başka sorum var']
    },
    {
      keys: ['iletişim','telefon','mail','e-posta','müşteri hizmetleri','destek','yardım','ulaşmak'],
      reply: '📞 Bize ulaşabilirsiniz:\n\n• <strong>WhatsApp:</strong> <a href="https://wa.me/905343345577" target="_blank" rel="noopener">905 343 345 577</a>\n• <strong>E-posta:</strong> destek@silcapmutfak.com\n• <strong>İade:</strong> iade@silcapmutfak.com\n• <strong>Çalışma saatleri:</strong> Hafta içi 09:00–18:00\n\nEn hızlı yanıt için WhatsApp veya e-posta kullanabilirsiniz.',
      suggestions: ['İade nasıl yapılır?', 'Sipariş durumum', 'Kargo bilgisi']
    },
    {
      keys: ['hediye','doğum günü','düğün','nişan','present','armağan'],
      reply: '🎁 Mutfak ürünlerimiz harika bir hediye seçeneği! Silikon kalıp setlerimiz, özel kutusunda sunulur ve ev hanımları ile pastacılık sevenler için çok değerli bir armağandır. Hediye paketi seçeneği de sunuyoruz!',
      suggestions: ['Hediye paketleme var mı?', 'En popüler setler', 'Fiyat aralığı']
    },
    {
      keys: ['stok','var mı','tükendi','mevcut','satın alınabilir'],
      reply: 'Stok durumu ürün sayfasında anlık olarak güncellenmektedir. "Stokta Yok" yazan ürünler için ürün sayfasındaki "Beni Haberdar Et" butonunu kullanarak stok girişinde bildirim alabilirsiniz.',
      suggestions: ['Ürün aramak istiyorum', 'Popüler ürünler', 'Başka sorum var']
    },
    {
      keys: ['teşekkür','teşekkürler','sağ ol','tamam','anladım','harika','çok iyi'],
      reply: '😊 Rica ederim! Başka bir sorunuz olursa her zaman buradayım. İyi alışverişler! 🛍️',
      suggestions: ['Ürünlere bak', 'Kampanyalar', 'Sipariş ver']
    }
  ];

  function generateReply(text) {
    var lower = text.toLowerCase()
      .replace(/[ğ]/g, 'g').replace(/[ı]/g, 'i').replace(/[ö]/g, 'o')
      .replace(/[ü]/g, 'u').replace(/[ş]/g, 's').replace(/[ç]/g, 'c');

    for (var i = 0; i < KB.length; i++) {
      for (var j = 0; j < KB[i].keys.length; j++) {
        var k = KB[i].keys[j]
          .replace(/[ğ]/g, 'g').replace(/[ı]/g, 'i').replace(/[ö]/g, 'o')
          .replace(/[ü]/g, 'u').replace(/[ş]/g, 's').replace(/[ç]/g, 'c');
        if (lower.indexOf(k) !== -1) {
          return KB[i];
        }
      }
    }
    return {
      reply: 'Sorunuzu aldım. 🤔 Daha iyi yardımcı olabilmem için biraz daha detay verir misiniz? Ya da aşağıdaki konulardan birini seçebilirsiniz:',
      suggestions: ['Kargo bilgisi', 'İade koşulları', 'Silikon kalıplar', 'İletişim']
    };
  }

  /* ── Mesaj gönder ────────────────────────────────────────── */
  function sendMessage() {
    var text = input ? input.value.trim() : '';
    if (!text) return;
    addMsg(text, 'user');
    if (input) input.value = '';
    hasInteracted = true;

    /* Öneri kutularını temizle */
    msgs.querySelectorAll('.ai-chatbot__suggestions').forEach(function(e) { e.remove(); });

    /* Yazıyor göster */
    var typing = showTyping();
    var delay = 600 + Math.random() * 600;

    setTimeout(function() {
      removeTyping();
      var result = generateReply(text);
      addMsg(result.reply.replace(/\n/g, '<br>'), 'bot');
      if (result.suggestions) addSuggestions(result.suggestions);
    }, delay);
  }

  /* ── Aç/Kapat ────────────────────────────────────────────── */
  function openChat() {
    isOpen = true;
    win.classList.add('is-open');
    win.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (iconOpen)  iconOpen.style.display  = 'none';
    if (iconClose) iconClose.style.display = '';
    if (unread) unread.style.display = 'none';
    setTimeout(function() { if (input) input.focus(); }, 200);
  }
  function closeChat() {
    isOpen = false;
    win.classList.remove('is-open');
    win.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (iconOpen)  iconOpen.style.display  = '';
    if (iconClose) iconClose.style.display = 'none';
  }

  toggle.addEventListener('click', function() { isOpen ? closeChat() : openChat(); });
  if (closeBtn) closeBtn.addEventListener('click', closeChat);
  if (sendBtn)  sendBtn.addEventListener('click', sendMessage);
  if (input) {
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });
  }

  /* ── İlk açılışta hoş geldin mesajı + öneriler ──────────── */
  /* Unread badge 3 sn sonra görünür */
  setTimeout(function() {
    if (!isOpen && unread) unread.style.display = 'flex';
  }, 3000);

  /* İlk açılışta welcome mesajı + öneriler ekle */
  toggle.addEventListener('click', function() {
    if (isOpen && !hasInteracted && msgs && msgs.children.length <= 1) {
      setTimeout(function() {
        addSuggestions(['Kargo süresi nedir?', 'İade nasıl yapılır?', 'Silikon kalıplar hakkında', 'Kampanyalar']);
      }, 300);
    }
  }, { once: true });

  /* ESC tuşuyla kapatma */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) closeChat();
  });
})();

/* ── Quick View Modal ────────────────────────────────────── */
(function() {
  var modal    = document.getElementById('QuickViewModal');
  var content  = document.getElementById('QuickViewContent');
  var closeBtn = document.getElementById('QuickViewClose');
  var backdrop = document.getElementById('QuickViewBackdrop');
  if (!modal) return;

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var handle = btn.dataset.quickView;
    if (!handle) return;
    if (content) content.innerHTML = '<div class="qv-modal__loading"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" stroke-width="2.5" class="loading-spinner"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".2"/><path d="M21 12a9 9 0 0 1-9 9"/></svg><p>Yükleniyor...</p></div>';
    openModal();
    try {
      var res = await fetch('/products/' + handle + '?sections=product-main', { headers: {'X-Requested-With':'XMLHttpRequest'} });
      if (res.ok) {
        var data = await res.json();
        var html = data['product-main'] || '';
        if (content) content.innerHTML = html || '<div style="padding:32px;text-align:center;"><a href="/products/' + handle + '" class="btn btn-primary">Ürün Sayfasına Git</a></div>';
      } else {
        if (content) content.innerHTML = '<div style="padding:32px;text-align:center;font-size:14px;color:var(--color-text-muted);">Yüklenemedi. <a href="/products/' + handle + '" style="color:var(--color-primary);">Ürün sayfasına git →</a></div>';
      }
    } catch(err) {
      if (content) content.innerHTML = '<div style="padding:32px;text-align:center;font-size:14px;color:var(--color-text-muted);">Bir hata oluştu. <a href="/products/' + handle + '" style="color:var(--color-primary);">Ürün sayfasına git →</a></div>';
    }
  });

  closeBtn?.addEventListener('click', closeModal);
  backdrop?.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });
})();

/* ── SSS sayfası — h2/h3 başlıklarını accordion yap ─────────── */
(function initSilcapPageFaq() {
  document.querySelectorAll('.silcap-about--faq .silcap-about__intro-content').forEach(function (body) {
    if (body.dataset.faqReady) return;
    var headings = body.querySelectorAll('h2, h3');
    if (!headings.length) return;
    body.dataset.faqReady = '1';
    headings.forEach(function (heading) {
      if (heading.closest('details')) return;
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.textContent = heading.textContent;
      details.appendChild(summary);
      var answer = document.createElement('div');
      answer.className = 'silcap-faq__answer';
      var node = heading.nextElementSibling;
      var toMove = [];
      while (node && !/^H[23]$/.test(node.tagName)) {
        toMove.push(node);
        node = node.nextElementSibling;
      }
      if (!toMove.length) {
        var p = document.createElement('p');
        p.textContent = 'Detaylı bilgi için müşteri hizmetlerimizle iletişime geçebilirsiniz.';
        answer.appendChild(p);
      } else {
        toMove.forEach(function (el) { answer.appendChild(el); });
      }
      details.appendChild(answer);
      heading.replaceWith(details);
    });
  });
})();
